import { useMutation, useQueryClient } from 'react-query';

import api from '@shared/api';
import { useActiveWorkspace } from '@shared/hooks';

async function updatePanelLibraryTemplate({
  name,
  templateId
}: {
  name: string;
  templateId: string;
}): Promise<void> {
  await api.put<void>(`code-panels/mpm/templates/${templateId}`, { name });
}

export function usePanelLibraryUpdateTemplateMutation() {
  const queryClient = useQueryClient();
  const activeWorkspace = useActiveWorkspace();
  const workspaceName = activeWorkspace.name;

  return useMutation(
    ({ name, templateId }: { name: string; templateId: string }) => {
      return updatePanelLibraryTemplate({
        name,
        templateId
      });
    },
    {
      onSuccess: async (_, { templateId }) => {
        await queryClient.invalidateQueries([
          'panel-library-templates',
          { workspaceName }
        ]);
        await queryClient.invalidateQueries([
          'panel-library-template',
          { templateId }
        ]);
      }
    }
  );
}
